import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import './StructuredAnalysisErrorCard.scss';

const StructuredAnalysisErrorCard = () => {
  return (
    <section
      className="structured-analysis-error"
      data-testid="structured-analysis-error"
    >
      <div>
        <Icon className="fill icon-orange" width="64" name="search-error" />
      </div>
      <div>
        <h1>Error Loading</h1>
      </div>
      <div>
        <h2>
          Unable to load data,
          <br />
          refresh the page to try again
        </h2>
      </div>
      <div>
        <button
          className="ui-button"
          type="button"
          onClick={() => window.location.reload()}
        >
          Reload Page
        </button>
      </div>
    </section>
  );
};

export default StructuredAnalysisErrorCard;
